var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-4"},_vm._l((_vm.Products),function(product){return _c('div',{key:product.id,staticClass:"px-1 w-100"},[_c('Product',{attrs:{"product":product}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }